/* Level-Finder Quiz — assets/level-quiz.js
   Vanilla JS, no dependencies. Loaded with `defer` by sections/level-quiz.liquid.
   Flow: intro → 7 questions → gate → Klaviyo subscribe + event → redirect to result page.
   Scoring mirrors the process-design doc exactly; change it there first, then here. */
(function () {
  'use strict';

  var root = document.querySelector('[data-level-quiz]');
  if (!root) return;

  /* ---------- Questions ---------- */
  var QUESTIONS = [
    {
      id: 'goal', key: 'quiz_goal',
      text: 'What do you want wine knowledge to do for you?',
      options: [
        { v: 'enjoy',  t: 'Enjoy wine more and talk about it with confidence' },
        { v: 'career', t: 'Start a career in the wine industry' },
        { v: 'advance', t: 'Move up in the wine industry job I already have' },
        { v: 'teach',  t: 'Teach wine or lead tastings' }
      ]
    },
    {
      id: 'self', key: 'quiz_self_rating', score: true,
      text: 'Where are you today, honestly?',
      options: [
        { v: 0, t: 'I know what I like, but not much about why' },
        { v: 1, t: 'I can talk about grapes and regions with some confidence' },
        { v: 2, t: 'I can taste a wine and explain its quality to someone else' },
        { v: 3, t: "I've studied wine formally and want to go deeper" }
      ]
    },
    {
      id: 'check', key: 'quiz_knowledge_check', score: true,
      text: 'Quick check. A red wine is pale in color with high acidity and high tannin. What comes to mind?',
      options: [
        { v: 0, t: "I wouldn't know how to guess" },
        { v: 1, t: 'Pinot Noir' },
        { v: 2, t: 'An aged Barolo' },
        { v: 3, t: 'Barolo, young or aged' }
      ]
    },
    {
      id: 'cert', key: 'quiz_prior_cert',
      text: 'Have you completed a wine certification?',
      options: [
        { v: 'none',    t: 'No' },
        { v: 'l1',      t: 'WSET Level 1 Award in Wines' },
        { v: 'l2',      t: 'WSET Level 2 Award in Wines' },
        { v: 'l3',      t: 'WSET Level 3 Award in Wines' },
        { v: 'diploma', t: 'WSET Level 4 Diploma in Wines' },
        { v: 'other',   t: 'Another wine credential (CMS, WSG, CSW, or similar)' }
      ]
    },
    {
      id: 'hours', key: 'quiz_hours',
      text: 'How much time can you give this each week?',
      options: [
        { v: '1-2', t: '1 to 2 hours' },
        { v: '3-5', t: '3 to 5 hours' },
        { v: '6+',  t: '6 hours or more' }
      ]
    },
    {
      id: 'format', key: 'quiz_format',
      text: 'How do you want to learn?',
      options: [
        { v: 'own_pace',   t: 'Online, at my own pace' },
        { v: 'instructor', t: 'Online, with instructor input' },
        { v: 'in_person',  t: 'In person, at the NVWA location nearest me' },
        { v: 'immersive',  t: 'A short immersive week in Napa' }
      ]
    },
    {
      id: 'state', key: 'quiz_state', type: 'select',
      text: 'Where are you based?',
      options: null // filled from US_STATES + Outside the US
    }
  ];

  var US_STATES = ['AL','AK','AZ','AR','CA','CO','CT','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];
  var STATE_NAMES = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'District of Columbia',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming'};
  QUESTIONS[6].options = US_STATES.map(function (s) { return { v: s, t: STATE_NAMES[s] }; }).concat([{ v: 'INTL', t: 'Outside the US' }]);

  /* ---------- Scoring (mirrors the process-design doc) ---------- */
  function score(a) {
    var self = Number(a.self), check = Number(a.check);
    // Disagreement rule: if the two scores differ by 2+, trust the lower one.
    if (Math.abs(self - check) >= 2) { var low = Math.min(self, check); self = low; check = low; }
    var total = self + check;
    var base = total <= 1 ? 'l1' : total <= 3 ? 'l2' : 'l3';
    var level = base, variant = '';

    // Credential floor
    if (a.cert === 'l1' && level === 'l1') level = 'l2';
    if (a.cert === 'l2' && level !== 'l3') level = 'l3';
    if (a.cert === 'other') { variant = 'cred'; } // other credentials set no floor; the line on the result explains the Diploma pathway
    if (a.cert === 'l3') { level = 'diploma'; }
    if (a.cert === 'diploma') { level = 'diploma'; variant = 'grad'; }

    var floored = a.cert !== 'none' && a.cert !== 'other';

    // Commitment rule (never lowers a floor)
    if (!floored && level === 'l3' && a.hours === '1-2' && a.goal === 'enjoy') { level = 'l2'; variant = 'commit'; }

    // Tasting bucket
    if (!floored && a.goal === 'enjoy' && total <= 1 && a.hours === '1-2') { level = 'tasting'; }

    return { level: level, variant: variant, total: total };
  }

  /* ---------- State ---------- */
  var STORE_KEY = 'nvwa_level_quiz';
  var state = load() || { i: 0, a: {}, startedAt: null };

  function load() { try { return JSON.parse(sessionStorage.getItem(STORE_KEY)); } catch (e) { return null; } }
  function save() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {} }

  /* ---------- Analytics ---------- */
  function track(name, params) {
    params = params || {};
    try {
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
      else { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); }
    } catch (e) {}
  }

  /* ---------- DOM ---------- */
  var screens = {
    intro: root.querySelector('[data-screen="intro"]'),
    question: root.querySelector('[data-screen="question"]'),
    gate: root.querySelector('[data-screen="gate"]')
  };
  var el = {
    start: root.querySelector('[data-start]'),
    back: root.querySelector('[data-back]'),
    progress: root.querySelector('[data-progress]'),
    stepLabel: root.querySelector('[data-step-label]'),
    question: root.querySelector('[data-question]'),
    options: root.querySelector('[data-options]'),
    form: root.querySelector('[data-gate-form]'),
    submit: root.querySelector('[data-submit]'),
    error: root.querySelector('[data-form-error]'),
    emailHint: root.querySelector('[data-email-hint]'),
    smsToggle: root.querySelector('[data-sms-toggle]'),
    phoneField: root.querySelector('[data-phone-field]')
  };

  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].classList.toggle('is-active', k === name); });
    window.scrollTo({ top: root.offsetTop - 16, behavior: 'auto' });
  }

  function renderQuestion() {
    var q = QUESTIONS[state.i];
    var n = state.i + 1;
    el.progress.style.width = Math.round((state.i / QUESTIONS.length) * 100) + '%';
    el.stepLabel.textContent = 'Question ' + n + ' of ' + QUESTIONS.length;
    el.question.textContent = q.text;
    el.options.innerHTML = '';
    el.back.hidden = state.i === 0;

    if (q.type === 'select') {
      var sel = document.createElement('select');
      sel.className = 'lq-select';
      sel.setAttribute('aria-label', q.text);
      var ph = document.createElement('option'); ph.value = ''; ph.textContent = 'Choose one'; sel.appendChild(ph);
      q.options.forEach(function (o) {
        var opt = document.createElement('option'); opt.value = o.v; opt.textContent = o.t;
        if (state.a[q.id] === o.v) opt.selected = true;
        sel.appendChild(opt);
      });
      sel.addEventListener('change', function () { if (sel.value) answer(q, sel.value); });
      el.options.appendChild(sel);
      sel.focus();
      return;
    }

    q.options.forEach(function (o, idx) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'lq-option'; b.textContent = o.t;
      if (String(state.a[q.id]) === String(o.v)) b.classList.add('is-selected');
      b.addEventListener('click', function () { answer(q, o.v); });
      if (idx === 0) setTimeout(function () { b.focus(); }, 0);
      el.options.appendChild(b);
    });
  }

  function answer(q, v) {
    state.a[q.id] = v;
    track('quiz_step', { step: state.i + 1, question: q.id });
    if (state.i < QUESTIONS.length - 1) { state.i += 1; save(); renderQuestion(); }
    else { save(); el.progress.style.width = '100%'; track('quiz_gate_view'); show('gate'); }
  }

  el.start.addEventListener('click', function () {
    state.startedAt = state.startedAt || Date.now();
    state.i = 0; save();
    track('quiz_start');
    show('question'); renderQuestion();
  });

  el.back.addEventListener('click', function () {
    if (state.i > 0) { state.i -= 1; save(); renderQuestion(); }
  });

  if (el.smsToggle) {
    el.smsToggle.addEventListener('change', function () { el.phoneField.hidden = !el.smsToggle.checked; });
  }

  /* ---------- Email guards ---------- */
  var DISPOSABLE = ['mailinator.com','guerrillamail.com','10minutemail.com','tempmail.com','temp-mail.org','yopmail.com','sharklasers.com','getnada.com','trashmail.com','dispostable.com','fakeinbox.com','maildrop.cc','throwawaymail.com','mohmal.com','emailondeck.com','mintemail.com','spamgourmet.com','tempr.email','discard.email','mailnesia.com'];
  var TYPOS = { 'gmial.com':'gmail.com','gmai.com':'gmail.com','gmail.co':'gmail.com','gmail.con':'gmail.com','gamil.com':'gmail.com','gnail.com':'gmail.com','yaho.com':'yahoo.com','yahoo.co':'yahoo.com','yahoo.con':'yahoo.com','hotmal.com':'hotmail.com','hotmail.co':'hotmail.com','hotmail.con':'hotmail.com','outlok.com':'outlook.com','outlook.con':'outlook.com','icloud.co':'icloud.com','iclould.com':'icloud.com' };

  function emailCheck(email) {
    var m = /^[^\s@]+@([^\s@]+\.[^\s@]{2,})$/.exec(email);
    if (!m) return { ok: false, msg: 'Enter a valid email address.' };
    var domain = m[1].toLowerCase();
    if (DISPOSABLE.indexOf(domain) !== -1) return { ok: false, msg: 'Please use a permanent email address so your result reaches you.' };
    if (TYPOS[domain]) return { ok: true, suggest: email.replace(domain, TYPOS[domain]) };
    return { ok: true };
  }

  var emailInput = el.form.querySelector('[name="email"]');
  emailInput.addEventListener('blur', function () {
    var r = emailCheck(emailInput.value.trim());
    el.emailHint.hidden = true; el.emailHint.innerHTML = '';
    if (r.suggest) {
      el.emailHint.hidden = false;
      el.emailHint.innerHTML = 'Did you mean <button type="button">' + r.suggest + '</button>?';
      el.emailHint.querySelector('button').addEventListener('click', function () { emailInput.value = r.suggest; el.emailHint.hidden = true; });
    }
  });

  /* ---------- Klaviyo (client-side, public key only) ---------- */
  var KLAVIYO_KEY = root.getAttribute('data-klaviyo-key');
  var KLAVIYO_LIST = root.getAttribute('data-klaviyo-list');
  var KLAVIYO_REV = '2024-10-15';

  function klaviyo(path, body) {
    // keepalive lets the request finish even after the page navigates to the result.
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KLAVIYO_KEY), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REV },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) { try { r.text().then(function (t) { console.warn('Klaviyo ' + path + ' ' + r.status, t); }); } catch (e) {} }
      return r;
    });
  }

  function buildProperties(result) {
    var a = state.a;
    return {
      quiz_level: result.level,
      quiz_variant: result.variant || '',
      quiz_goal: a.goal,
      quiz_experience: result.total,
      quiz_self_rating: Number(a.self),
      quiz_knowledge_check: Number(a.check),
      quiz_prior_cert: a.cert,
      quiz_hours: a.hours,
      quiz_format: a.format,
      quiz_state: a.state,
      quiz_diploma_graduate: result.variant === 'grad',
      quiz_date: new Date().toISOString().slice(0, 10)
    };
  }

  function subscribe(profile, props, smsPhone) {
    // Minimal payload: list subscription only. Name and quiz answers are written by sendEvent().
    // Fix Oct 19 2026: Klaviyo rejected a nested `subscriptions` object on the profile (400).
    var attrs = { email: profile.email };
    if (smsPhone) { attrs.phone_number = smsPhone; }
    return klaviyo('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { custom_source: 'Level Quiz', profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      }
    });
  }

  function sendEvent(profile, props) {
    return klaviyo('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: 'Completed Level Quiz' } } },
          profile: { data: { type: 'profile', attributes: { email: profile.email, first_name: profile.first_name, properties: props } } }
        }
      }
    });
  }

  /* ---------- Gate submit ---------- */
  el.form.addEventListener('submit', function (e) {
    e.preventDefault();
    el.error.hidden = true;

    var fd = new FormData(el.form);
    var first = (fd.get('first_name') || '').toString().trim();
    var email = (fd.get('email') || '').toString().trim();
    var hp = (fd.get('website') || '').toString();
    var wantsSms = !!fd.get('sms_opt_in');
    var phone = (fd.get('phone') || '').toString().replace(/[^\d+]/g, '');

    // Bot guards: honeypot filled, or finished faster than a human could.
    var minSeconds = Number(root.getAttribute('data-min-seconds') || 12);
    if (hp || !state.startedAt || (Date.now() - state.startedAt) / 1000 < minSeconds) {
      el.error.hidden = false; el.error.textContent = 'Something went wrong. Please retake the quiz.';
      return;
    }

    if (!first) { fail('Add your first name so we can address you.'); return; }
    var ec = emailCheck(email);
    if (!ec.ok) { fail(ec.msg); return; }
    if (wantsSms) {
      if (phone.indexOf('+') !== 0) phone = '+1' + phone.replace(/^1/, '');
      if (!/^\+1\d{10}$/.test(phone)) { fail('Enter a US mobile number, or untick the text option.'); return; }
    } else { phone = ''; }

    var result = score(state.a);
    var props = buildProperties(result);
    var profile = { email: email, first_name: first };

    el.submit.disabled = true;
    track('quiz_complete', { result: result.level, variant: result.variant || 'none', goal: state.a.goal, format: state.a.format });

    // Fire both; redirect regardless of network outcome so the person always sees their result.
    var done = false;
    function go() {
      if (done) return; done = true;
      try { sessionStorage.removeItem(STORE_KEY); } catch (err) {}
      var base = root.getAttribute('data-result-base') || '/pages/your-level-';
      var qs = '?g=' + encodeURIComponent(state.a.goal) + '&f=' + encodeURIComponent(state.a.format) + '&s=' + encodeURIComponent(state.a.state) + (result.variant ? '&v=' + encodeURIComponent(result.variant) : '');
      window.location.href = base + result.level + qs;
    }
    var timer = setTimeout(go, 4000);
    Promise.allSettled([subscribe(profile, props, phone), sendEvent(profile, props)]).then(function () { clearTimeout(timer); go(); });

    function fail(msg) { el.error.hidden = false; el.error.textContent = msg; }
  });

  /* ---------- Resume mid-quiz on refresh ---------- */
  if (state.startedAt && state.i > 0 && state.i < QUESTIONS.length) { show('question'); renderQuestion(); }
  else if (state.startedAt && Object.keys(state.a).length === QUESTIONS.length) { show('gate'); }
})();
